(() => {
  if (window.krumelWhiskFeedback) return;
  window.krumelWhiskFeedback = true;
  const root = document.getElementById('krumel-whisk-feedback');
  if (!root) return;
  let timer;
  function hide() {
    clearTimeout(timer);
    root.hidden = true;
    root.classList.remove('is-navigation');
  }
  function show(navigation) {
    clearTimeout(timer);
    root.classList.toggle('is-navigation', navigation);
    root.hidden = false;
    // A stalled request must never leave the customer trapped behind a loader.
    timer = setTimeout(hide, navigation ? 10000 : 750);
  }
  document.addEventListener('click', event => {
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const target = event.target.closest('a, button, summary, input[type="submit"], [role="button"]');
    if (!target || target.disabled || target.getAttribute('aria-disabled') === 'true') return;
    if (target.matches('a')) {
      if (target.hasAttribute('download') || (target.target && target.target !== '_self')) return;
      const url = new URL(target.href, location.href);
      if (!/^https?:$/.test(url.protocol) || url.origin !== location.origin) return;
      const samePage = url.pathname === location.pathname && url.search === location.search;
      if (samePage && url.hash) { hide(); return; }
      show(true);
    } else {
      // Local controls retain their own in-button feedback; no page overlay.
      hide();
    }
  });
  document.addEventListener('submit', event => {
    if (event.defaultPrevented) return;
    const form = event.target;
    if (form.target && form.target !== '_self') return;
    if (form.closest('product-form') || form.matches('[data-type="add-to-cart-form"]') || /\/cart\/add(?:\.js)?(?:[?#]|$)/.test(form.action)) {
      hide();
      return;
    }
    show(true);
  });
  document.addEventListener('krumel:added', hide);
  window.addEventListener('pageshow', hide);
  window.addEventListener('pagehide', hide);
  window.addEventListener('popstate', hide);
  document.addEventListener('keydown', event => { if (event.key === 'Escape') hide(); });
})();
